'use client';

import { c as _c } from "react/compiler-runtime";
import { DirectionIcon, TextButton } from '@/shared/ui/atoms';
import { getHospitalAnalysisDisplayLabel } from '@/entities/hospital/lib/analysis-label-localization';
import { useLocale, useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { shallow } from 'zustand/shallow';
import useTreatmentCaseUIStore from '@/widgets/treatment-case/model/ui/store';
import { TREATMENT_CASE_SORT_OPTIONS, TREATMENT_CASE_SORT, type TreatmentCaseSort, type TreatmentCaseSubject } from '@/shared/types/type/treatment';
interface TreatmentCaseSubjectFilterProps {
  subjectFilterList: TreatmentCaseSubject[];
}
const TreatmentCaseSubjectFilter = t0 => {
  const $ = _c(45);
  const {
    subjectFilterList
  } = t0;
  const locale = useLocale();
  const t = useTranslations();
  const {
    selectedSort,
    selectedSubjectId,
    setSelectedSort,
    setSelectedSubjectId
  } = useTreatmentCaseUIStore(_temp, shallow);
  let t1;
  if ($[0] !== locale) {
    t1 = item => {
      const displayName = getHospitalAnalysisDisplayLabel(item.treatmentSubjectName, locale);
      return displayName ? [{
        ...item,
        displayName
      }] : [];
    };
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const localizedSubjectFilterList = subjectFilterList.flatMap(t1);
  let t2;
  if ($[2] !== t) {
    t2 = sort => sort === TREATMENT_CASE_SORT.VIEW_COUNT_DESC ? t("treatmentCaseFilter.popular") : t("treatmentCaseFilter.latest");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getSortLabel = t2;
  let t3;
  if ($[4] !== selectedSort || $[5] !== setSelectedSort) {
    t3 = sorting => {
      if (selectedSort !== sorting) {
        setSelectedSort(sorting);
      }
    };
    $[4] = selectedSort;
    $[5] = setSelectedSort;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleSelectSorting = t3;
  let t4;
  if ($[7] !== selectedSubjectId) {
    t4 = subject => `shrink-0 py-2 px-[14px] whitespace-nowrap rounded-full ${selectedSubjectId === subject ? "bg-gray-700 text-white" : "text-gray-800 bg-gray-100"}`;
    $[7] = selectedSubjectId;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const subjectClassName = t4;
  let t5;
  let t6;
  if ($[9] !== setSelectedSort || $[10] !== setSelectedSubjectId) {
    t5 = () => () => {
      setSelectedSort(TREATMENT_CASE_SORT.CREATED_AT_DESC);
      setSelectedSubjectId(0);
    };
    t6 = [setSelectedSort, setSelectedSubjectId];
    $[9] = setSelectedSort;
    $[10] = setSelectedSubjectId;
    $[11] = t5;
    $[12] = t6;
  } else {
    t5 = $[11];
    t6 = $[12];
  }
  useEffect(t5, t6);
  const t7 = "relative w-full min-w-0 max-w-full overflow-hidden";
  const t8 = "flex w-full min-w-0 max-w-full items-start justify-start gap-1.5 bg-white py-4 pl-4";
  let t9;
  if ($[13] !== t) {
    t9 = t("treatmentCaseFilter.sortAriaLabel");
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== handleSelectSorting) {
    t10 = e => handleSelectSorting(e.target.value as TreatmentCaseSort);
    $[15] = handleSelectSorting;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      "--fs": 15,
      "--lh": 22
    };
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== getSortLabel) {
    t12 = TREATMENT_CASE_SORT_OPTIONS.map(opt => <option key={opt} value={opt}>{getSortLabel(opt)}</option>);
    $[18] = getSortLabel;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== selectedSort || $[21] !== t10 || $[22] !== t12 || $[23] !== t9) {
    t13 = <select aria-label={t9} value={selectedSort} onChange={t10} className="fs min-w-[82px] appearance-none bg-transparent py-2 pl-3 pr-8 text-[15px] leading-[22px] text-gray-900 font-medium outline-none" style={t11 as React.CSSProperties}>{t12}</select>;
    $[20] = selectedSort;
    $[21] = t10;
    $[22] = t12;
    $[23] = t9;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-gray-400"><DirectionIcon size={16} className="text-gray-400" strokeWidth="1.3" /></span>;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t13) {
    t15 = <div className="relative flex w-fit shrink-0 flex-col items-center justify-center rounded-full border border-gray-200"><div className="relative flex items-center justify-center">{t13}{t14}</div></div>;
    $[26] = t13;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  const t16 = "min-w-0 max-w-full flex-1 overflow-x-auto overflow-y-visible pr-4 scrollbar-hide";
  const t17 = "flex w-max items-start justify-start gap-1.5";
  let t18;
  if ($[28] !== t) {
    t18 = t("treatmentCaseFilter.all");
    $[28] = t;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  const t19 = subjectClassName(0);
  let t20;
  if ($[30] !== setSelectedSubjectId) {
    t20 = () => {
      setSelectedSubjectId(0);
    };
    $[30] = setSelectedSubjectId;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] !== t18 || $[33] !== t19 || $[34] !== t20) {
    t21 = <TextButton key="subject-filter-0" text={t18} className={t19} onClick={t20} />;
    $[32] = t18;
    $[33] = t19;
    $[34] = t20;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== setSelectedSubjectId || $[37] !== subjectClassName) {
    t22 = item_0 => <TextButton key={`subject-filter-${item_0.treatmentSubjectId}`} text={item_0.displayName} className={subjectClassName(item_0.treatmentSubjectId)} onClick={() => {
      setSelectedSubjectId(item_0.treatmentSubjectId);
    }} />;
    $[36] = setSelectedSubjectId;
    $[37] = subjectClassName;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  const t23 = localizedSubjectFilterList.map(t22);
  let t24;
  if ($[39] !== t21 || $[40] !== t23) {
    t24 = <div className={t16}><div className={t17}>{t21}{t23}</div></div>;
    $[39] = t21;
    $[40] = t23;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t15 || $[43] !== t24) {
    t25 = <div className={t7}><div className={t8}>{t15}{t24}</div></div>;
    $[42] = t15;
    $[43] = t24;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  return t25;
};
export default TreatmentCaseSubjectFilter;
function _temp(s) {
  return {
    selectedSort: s.selectedSort,
    selectedSubjectId: s.selectedSubjectId,
    setSelectedSort: s.setSelectedSort,
    setSelectedSubjectId: s.setSelectedSubjectId
  };
}